// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4142":"f2b55db1","9545":"e3db5f93"}[chunkId] + ".chunk.css";
};